// extracted by mini-css-extract-plugin
module.exports = {"largeImage":"ArtecoSection-module--largeImage--37IlO","smallImage":"ArtecoSection-module--smallImage--33NT4"};